import { shallow } from "zustand/shallow";

import useMeetingReport from "@app/analytics/MeetingReport/hooks/useMeetingReport";
import useVideoRecording from "@app/analytics/MeetingReport/hooks/useVideoRecording";
import useVideoStore from "@app/analytics/MeetingReport/stores/video";
import { getClosestInTrendSeries } from "@app/analytics/MeetingReport/utils/videoUtils";

const DEFAULT_OVERLAYS: {
  [k in "meetingScore" | "engagement" | "sentiment"]: number | null;
} = {
  meetingScore: null,
  engagement: null,
  sentiment: null,
};

const useVideoMetricOverlays = () => {
  const { isLoading, meetingReport } = useMeetingReport();
  const { videoRecording } = useVideoRecording();

  const { currentTimestamp, metricAnnotationsEnabled, trailerActive } =
    useVideoStore(
      (state) => ({
        currentTimestamp: state.currentTimestamp,
        metricAnnotationsEnabled: state.metricAnnotationsEnabled,
        trailerActive: state.trailer.active,
      }),
      shallow
    );

  if (isLoading || trailerActive || !metricAnnotationsEnabled) {
    return DEFAULT_OVERLAYS;
  }

  const relativeTimestamp = videoRecording?.startTime
    ? videoRecording.startTime.toMillis() + currentTimestamp * 1000
    : 0;

  const meetingScorePoint = getClosestInTrendSeries(
    meetingReport?.callScoreTrend ?? [],
    relativeTimestamp
  );

  const engagementPoint = getClosestInTrendSeries(
    meetingReport?.engagementTrend ?? [],
    relativeTimestamp
  );

  const sentimentPoint = getClosestInTrendSeries(
    meetingReport?.sentimentTrend ?? [],
    relativeTimestamp
  );

  const overlays: typeof DEFAULT_OVERLAYS = {
    meetingScore: meetingScorePoint ? Math.round(meetingScorePoint.y) : null,
    engagement: engagementPoint ? Math.round(engagementPoint.y) : null,
    sentiment: sentimentPoint ? Math.round(sentimentPoint.y) : null,
  };

  return overlays;
};

export default useVideoMetricOverlays;
